import { createContext } from "react";
import { Site } from "../../types/Site";

export type CurrentSiteContextType = {
  currentSite: Site;
  setCurrentSite: (s: Site) => void;
};
export const CurrentSiteContext = createContext<CurrentSiteContextType>(undefined);
